export const HOME_FLOW_KEY = "mynetgoals-home-banner-flow";
export const HOME_FLOW_RESET_EVENT = "mynetgoals-home-flow-reset";

/** Sentence case — tooltips, descriptions, admin copy */
export const PAGEANT_SECTION_NAME = "Fashion Designers & Beauty Pageant Events";

/** Uppercase — hero titles, auth/onboarding labels, header alt text */
export const PAGEANT_SECTION_NAME_UPPER = "FASHION DESIGNERS & BEAUTY PAGEANT EVENTS";

/** @deprecated Use PAGEANT_SECTION_NAME_UPPER */
export const BEAUTY_PAGEANT_LABEL = PAGEANT_SECTION_NAME_UPPER;

export const PAGEANT_EVENTS_TITLE = PAGEANT_SECTION_NAME_UPPER;

export const PAGEANT_EVENTS_DESCRIPTION =
  "Search and open Fashion Designers & Beauty Pageant Events to join, upload one video or image per event, and vote for contestants or designers.";

export const PAGEANT_EVENTS_SEARCH_PLACEHOLDER =
  "Search Fashion Designers & Beauty Pageant Events…";

export const ADVOCACY_PLATFORM_LABEL = "Advocacy Platform";

/** Admin copy for the home chooser cards */
export const SECTION_SWITCH_LABEL = `Football / ${PAGEANT_SECTION_NAME}`;

/** Short header button label (space-constrained) */
export const SECTION_SWITCH_PAGEANT_LABEL = "Fashion & Pageant";
export const SECTION_SWITCH_FOOTBALL_LABEL = "Football";

export const getSectionSwitchLabel = (isPageantSection) =>
  isPageantSection ? SECTION_SWITCH_FOOTBALL_LABEL : SECTION_SWITCH_PAGEANT_LABEL;

export const getSectionSwitchAriaLabel = (isPageantSection) =>
  isPageantSection
    ? "Switch to Football"
    : `Switch to ${PAGEANT_SECTION_NAME}`;

export const getSectionSwitchTooltip = (isPageantSection) =>
  isPageantSection
    ? "Switch to Football — goal stream & leaderboards"
    : `Switch to ${PAGEANT_SECTION_NAME} — competitions, designers & voting`;

/** Direct navigation between Football home and Pageant competitions */
export const switchToOtherSection = ({ isPageantSection, navigate }) => {
  if (isPageantSection) {
    setFootballFlow();
    navigate("/");
    return;
  }
  setPageantFlow();
  navigate("/competitions");
};

export const getHomeFlow = () => sessionStorage.getItem(HOME_FLOW_KEY);

export const setFootballFlow = () => {
  sessionStorage.setItem(HOME_FLOW_KEY, "existing");
};

export const setPageantFlow = () => {
  sessionStorage.setItem(HOME_FLOW_KEY, "pageant");
};

export const clearHomeFlow = () => {
  sessionStorage.removeItem(HOME_FLOW_KEY);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(HOME_FLOW_RESET_EVENT));
  }
};

/** True when banner category/name should open pageant competitions */
export const isPageantBanner = (banner) => {
  const raw = [
    banner?.homeBannerCategory?.name,
    banner?.homeBannerCategory?.slug,
    banner?.category_name,
    banner?.title,
    banner?.name,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return /pageant|competition|beauty|contest|fashion designer|my beauty pageant/.test(raw);
};
